/**
 * @packageDocumentation
 * @module Array
 */
import { assert } from '../others';
/**
 * Function that checks if both arrays have the same values i.e. the same number of occurring values in each array
 *
 * @example doArraysHaveSameValues(['a','a','b'], ['a','b','b']) returns false
 * @example doArraysHaveSameValues(['a','b'], ['b','a']) returns true
 *
 * @param {any[]} a
 * @param {any[]} b
 *
 * @return {boolean}
 */
export function doArraysHaveSameValues(a, b) {
    assert(Array.isArray(a) && Array.isArray(b), 'Invalid argument(s) given, expecting array');
    // If the same array they have to have the same items
    if (a === b) {
        return true;
    }
    // If they don't have the same length, then we know they do not have the same values
    if (a.length !== b.length) {
        return false;
    }
    var valueOccurrences = new Map();
    var valueOccurrenceCount;
    // First get the values and count the occurrences
    a.forEach(function (value) {
        var _a;
        valueOccurrenceCount = (_a = valueOccurrences.get(value)) !== null && _a !== void 0 ? _a : 0;
        valueOccurrences.set(value, valueOccurrenceCount + 1);
    });
    // We are using `some` because it stops iteration as soon as true is returned, this is not the
    // same as `forEach`
    // Then we want to find out if b does not have some value or # of occurrences of value
    var arraysAreNotTheSame = b.some(function (value) {
        valueOccurrenceCount = valueOccurrences.get(value);
        // The values does not exist in a
        // or we have more of value in b then a has
        if (!valueOccurrenceCount) {
            return true;
        }
        // Decrement the occurrence count, since it was "used up" with this match
        valueOccurrences.set(value, valueOccurrenceCount - 1);
        return false;
    });
    return !arraysAreNotTheSame;
}
//# sourceMappingURL=doArraysHaveSameValues.js.map